<nav class="dropdown">
  <button
    type="button"
    class="dropdown__button"
    [attr.aria-label]="'publicNav.more' | translate"
    [attr.aria-expanded]="isOpen"
    (click)="toggleDesktopMenu(!isOpen)">
    <img src="assets/brand/menu-lines.svg" alt="" class="size-6" />
  </button>
  @if (isOpen) {
    <ul
      class="menu menu--sub"
      [ngClass]="{ open: isOpen }"
      [appOutSideClick]="isOpen"
      (outSideClick)="isOpen = false">
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'fur-fachkrafte'"
          (click)="handleClick()">
          {{ 'publicNav.forProfessionals' | translate }}
        </a>
      </li>
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'team'"
          (click)="handleClick()">
          {{ 'publicNav.about' | translate }}
        </a>
      </li>
      <li class="menu__item">
        <a
          class="menu__item__link"
          [href]="url + 'kontakt'"
          (click)="handleClick()">
          {{ 'publicNav.contact' | translate }}
        </a>
      </li>
    </ul>
  }
</nav>
